<template>
  <div ref="map" class="h-full w-full"></div>
</template>

<script>
import { mapboxToken } from "@/lib/mapboxConfig";
import colors from "@/services/colors";
import mapboxgl from "mapbox-gl";

export default {
  props: {
    data: {
      type: Array,
      required: false,
    },
    controls: {
      type: Boolean,
      default: true
    },
  },

  data() {
    let loadResolver
    const loadPromise = new Promise(resolve => {
      loadResolver = (map) => {
        resolve(map)
      }
    })

    return {
      loadPromise,
      loadResolver,
      map: null,
    }
  },

  watch: {
    data() {
      this.init()
    }
  },

  beforeDestroy() {
    
    if(this.map) {
      this.map.remove()
    }
  },

  async mounted() {
    mapboxgl.accessToken = mapboxToken;
    const map = new mapboxgl.Map({
      container: this.$refs.map,
      style: "mapbox://styles/mapbox/light-v10",
      minZoom: 3,
      maxZoom: 14,
      bounds: [
        [5, 36],
        [20, 48],
      ],
      dragPan: this.controls,
      dragRotate: this.controls,
      doubleClickZoom: this.controls,
      touchZoomRotate: this.controls,
      scrollZoom: this.controls,
      boxZoom: this.controls
    });
    this.map = map
    
    map.on('load', () => {
      this.$emit('load', map)
      this.loadResolver(map)
    })
    this.init()
  },

  methods: {
     async init() {
      const map = await this.loadPromise;
      if(this.data) {
        const data = this.data;

        const total = this.data.reduce((t, d) => t + d.length, 0)
        const opacity = 0.9 - 0.125 * (data.length - 1)


        for(let i = 0; i < Math.min(data.length, colors.length); i++) {
          let features;

          if(data[i]) {
            features = data[i].map(coordinates => ({
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates,
              },
            }));
          } else {
            break;
          }

          const sourceName = 'votes' + i;
          const clusterName = 'clustered' + i;
          const unclusteredName = 'unclustered' + i;

          const source = map.getSource(sourceName)

          if(source) {
            source.setData({
              type: "FeatureCollection",
              features,
            })
          } else {
            map.addSource(sourceName, {
              type: "geojson",
              cluster: true,
              clusterMaxZoom: 17,
              clusterRadius: 50,
              data: {
                type: "FeatureCollection",
                features,
              },
            });
          }

          if(map.getLayer(clusterName)) {
            map.removeLayer(clusterName)
            map.removeLayer(unclusteredName)
          }

          if(data[i]) {
            map.addLayer({
              id: clusterName,
              type: "circle",
              source: sourceName,
              filter: ["has", "point_count"],
              paint: {
                "circle-color": colors[i],
                "circle-opacity": opacity,
                "circle-radius": [
                  "+",
                  2, 
                  [
                    "*",
                    50,
                    [
                      "/",
                      ["get", "point_count"],
                      total
                    ]
                  ]
                ]
              },
            });

            map.addLayer({
              id: unclusteredName,
              type: "circle",
              source: sourceName,
              filter: ["!", ["has", "point_count"]],
              paint: {
                "circle-color": colors[i],
                "circle-opacity": opacity,
                "circle-radius": 2 + 50 / total
              },
            });
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.blurred {
  filter: blur(.25rem)
}
</style>